import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import UserContext from '../tools/contextLib'
import { browserName, browserVersion } from 'react-device-detect';
import axios from 'axios';
import { UnderConstruction } from './UnderConstruction';
import UnderConstructionPDF from '../Documents/UnderConstruction.pdf';
import moment from 'moment';


export class Home extends Component {
    static displayName = Home.name;

    constructor(props) {
        super(props);
        //this.toggle = this.toggle.bind(this);//Anything in here with toggle in it is a relic from when the level dropdown was in here, at first by design and then for testing. 
                                             //It can be removed since this page has almost nothing on it by design now.
        this.state = {
            loading: true,
            returnable: [],
            //selectable: ["3", "4"],//This is another relic of the days when the dropdown was in here
            level: [],
            globalLevel: "",
            IP: "",
            browser: `${browserName}${browserVersion}`,
            username: "",
            bearerVAR: "Bearer " + localStorage.getItem("webApiAccessToken")
        };
        this.getData();
        
    }
    //toggle() {
    //    this.setState(prevState => ({
    //        dropdownOpen: !prevState.dropdownOpen
    //    }));
    //}

    componentDidMount() {
        
    }

    async getData() { //This chain of functions is used pretty much exclusively for logging purposes in this component
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        }, () => { this.getUserInfo(); })
        
        
    }

    async recordComingHere() { //An interesting thing about the logging functions is that it seems to fire around three to five times every time a component loads, but 
                               //only the last time does it actually have all the information it needs to have. Figuring out why should be on the list of things to do.
                               //For the moment, it's controlled by ignoring logging fetches that don't have all the important information on the controller level
         let toSend = {
             pagePK: "1",
             department: this.state.returnable.level,
             userPCID: this.state.returnable.pcid,
             ip: this.state.ip,
             browser: this.state.browser,
             userID: this.state.returnable.username
        }
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
         const response = await fetch('logging', {
             method: 'POST',
             headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
             body: JSON.stringify(toSend)
         });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //console.log("Home getUserInfo bearerVAR: " + bearerVAR)
        const response = await fetch('user', {
            method: 'GET',
            headers: { 'Authorization': bearerVAR }
        });
        const data = await response.json();
        this.setState({
            returnable: data,
            loading: false,
            selectables: data.values,
            username: data.username
        }, () => { this.recordComingHere(); });//20230509: moving this.recordComingHere(); into a this.setState({}) callback to try and make sure we're always logging when there's data to log
        localStorage.setItem("lastFetch", moment());
    }

    render() {
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <h1>Hello, {contextData[1]}. You're looking good today.</h1><br />
                    </div>)}
            </UserContext.Consumer>
        );//contextData[1] should be the user's display name
    }
}
